const projects = [
  {
    id: "osteria-hub",
    index: "01",
    title: "Osteria Hub",
    category: "Hospitality / Restaurant",
    year: "2024",
    role: "Design & Development",
    client: "Italian Restaurant Concept",
    liveUrl: "https://osteria-hub-1.preview.emergentagent.com/",
    cover: "/screenshots/osteria-hub-desktop.jpg",
    desktop: "/screenshots/osteria-hub-desktop.jpg",
    desktopAlt: "/screenshots/osteria-hub-desktop-2.jpg",
    mobile: "/screenshots/osteria-hub-mobile.jpg",
    tech: ["React", "Tailwind CSS", "Framer Motion", "Responsive Design"],
    short:
      "An Italian dining experience translated into warm, atmospheric web design.",
    description:
      "A restaurant website concept designed to showcase an Italian dining experience with a warm and professional online presence. The site focuses on presenting the restaurant's atmosphere, menu, and contact information in a clean and engaging way, helping visitors quickly understand the brand and take action.",
    highlights: [
      "Editorial menu layout with photographic storytelling",
      "Reservation-first information architecture",
      "Mobile-first, performance-optimized build",
    ],
  },
  {
    id: "beauty-relax",
    index: "02",
    title: "Beauty & Relax",
    category: "Beauty / Wellness",
    year: "2024",
    role: "Design & Development",
    client: "Beauty & Wellness Studio",
    liveUrl: "https://beauty-relax-landing.preview.emergentagent.com/",
    cover: "/screenshots/beauty-relax-desktop.jpg",
    desktop: "/screenshots/beauty-relax-desktop.jpg",
    desktopAlt: "/screenshots/beauty-relax-desktop-2.jpg",
    mobile: "/screenshots/beauty-relax-mobile.jpg",
    tech: ["React", "Tailwind CSS", "Lucide Icons", "Mobile-first"],
    short:
      "Calm, elegant landing page built to convert curiosity into bookings.",
    description:
      "A stylish landing page created for a beauty and wellness business, designed to communicate calm, professionalism, and trust. The website presents services in an elegant way, with a relaxing visual style, clear section structure, and mobile-friendly navigation that makes it easy for visitors to explore treatments and get in contact.",
    highlights: [
      "Service-driven layout that guides booking decisions",
      "Soft palette and generous spacing for a spa-like feel",
      "Optimized contact path for mobile-first users",
    ],
  },
  {
    id: "espresso-express",
    index: "03",
    title: "Espresso Express",
    category: "F&B / Coffee Brand",
    year: "2024",
    role: "Design & Development",
    client: "Coffee & Beverage Brand",
    liveUrl: "https://espresso-express-12.preview.emergentagent.com/",
    cover: "/screenshots/espresso-express-desktop.jpg",
    desktop: "/screenshots/espresso-express-desktop.jpg",
    desktopAlt: "/screenshots/espresso-express-desktop-2.jpg",
    mobile: "/screenshots/espresso-express-mobile.jpg",
    tech: ["React", "Tailwind CSS", "Modern CTAs", "Brand-led visuals"],
    short:
      "A fast, warm ordering experience built on confident visual branding.",
    description:
      "A modern landing page concept for a coffee and beverage brand, designed to present a fast, warm, and convenient ordering experience. The website focuses on strong visual branding, clear calls to action, and a smooth user journey for customers looking to explore products, learn about the brand, and place an order quickly.",
    highlights: [
      "High-contrast visual branding with strong photography",
      "Clear ordering CTA from hero through to footer",
      "Frictionless mobile journey",
    ],
  },
  {
    id: "kulturverein-erfurt",
    index: "04",
    title: "Syrischer Kulturverein Erfurt",
    category: "Non-Profit / Multilingual",
    year: "2024",
    role: "Design, Development & Localisation",
    client: "Syrischer Kulturverein Erfurt e.V.",
    liveUrl: "https://syrischerkulturvereinerfurt.de/",
    cover: "/screenshots/kulturverein-erfurt-desktop.jpg",
    desktop: "/screenshots/kulturverein-erfurt-desktop.jpg",
    desktopAlt: "/screenshots/kulturverein-erfurt-desktop-2.jpg",
    mobile: "/screenshots/kulturverein-erfurt-mobile.jpg",
    tech: ["Multilingual i18n", "Responsive Web", "Accessibility", "SEO"],
    short:
      "A multilingual presence for a cultural association in Erfurt, Germany.",
    description:
      "A modern multilingual website developed for a cultural association in Erfurt, designed to present the organization's mission, activities, and community work in a clear and accessible way. The site focuses on trust, readability, and easy navigation, with structured content for visitors looking for information about the association, events, and contact details.",
    highlights: [
      "Multilingual content with clean language switching",
      "Structured information architecture for events and contact",
      "Accessibility and readability as first-class citizens",
    ],
  },
  {
    id: "hamscho-fahrschule",
    index: "05",
    title: "Hamscho Fahrschule",
    category: "Education / Local Business",
    year: "2024",
    role: "Design & Development",
    client: "Hamscho Fahrschule",
    liveUrl: "https://hamscho-fahrschule.com/",
    cover: "/screenshots/hamscho-fahrschule-desktop.jpg",
    desktop: "/screenshots/hamscho-fahrschule-desktop.jpg",
    desktopAlt: "/screenshots/hamscho-fahrschule-desktop-2.jpg",
    mobile: "/screenshots/hamscho-fahrschule-mobile.jpg",
    tech: ["React", "Tailwind CSS", "Local SEO", "Mobile-first"],
    short:
      "A trust-driven driving school website built around fast registration.",
    description:
      "A professional driving school website built to help students quickly understand the school's services, contact the team, and start their registration journey. The design focuses on clarity, local trust, and mobile-friendly navigation, making it easy for users to find the information they need and take action.",
    highlights: [
      "Clear, scannable services and pricing presentation",
      "Local SEO and trust signals throughout",
      "Optimized registration call-to-action paths",
    ],
  },
];

export const getProjectById = (id) => projects.find((p) => p.id === id);
export default projects;
